import { Component } from '@angular/core';
import { AuthService } from '../../services/auth.service';

/** Shown when the API keeps rejecting tokens identity issues. It calls no API. */
@Component({
  templateUrl: 'session-error.component.html'
})
export class SessionErrorComponent {
  signingOut = false

  constructor(private authService: AuthService) { }

  retry() {
    location.assign('/')
  }

  async signOut() {
    this.signingOut = true
    await this.authService.logout()
  }
}
